var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_vm._v(" Activity Details "),_c('v-row',[_c('v-col',[_c('v-form',{ref:"form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }